import dataProvider from "src/dataProvider";

let fetcher = dataProvider("adminInstance");

const endPoints = {
  gcaDetails: "/user/gca",
  gcaList: "/user/gca/list",
};

export const getGCADetails = async (gcaId: string) => {
  return fetcher.get(`${endPoints.gcaDetails}/${gcaId}`);
};

export const getGCAList = async (queryParams?: any) => {
  return fetcher.get(endPoints.gcaList, queryParams);
};

export const updateGCAProfile = async (gcaId: string, data: any) => {
  return fetcher.put(`${endPoints.gcaDetails}/${gcaId}`, data);
};

export const approveGCA = async (gcaId: string) => {
  return fetcher.post(`${endPoints.gcaDetails}/${gcaId}/approve`, {});
};

export const rejectGCA = async (gcaId: string, reason: string) => {
  return fetcher.post(`${endPoints.gcaDetails}/${gcaId}/reject`, { reason });
};

export const updateProfileComprehensive = async (
  userId: string,
  payload: any,
) => {
  return fetcher.post(
    `${endPoints.gcaDetails}/update-profile/${userId}`,
    payload,
  );
};
export const getGCAUserUpdateHistory = async (userId: string) => {
  return fetcher.get(`${endPoints.gcaDetails}/update-history/${userId}`);
};
